
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 46 46"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"22.5","cy":"22.5","r":"22.5","fill":"#4fa2b7"}}),_c('path',{attrs:{"d":"M30.1 18.9c-2.3-3.9-7.2-5.2-11.1-3-1.4.8-2.5 2-3.2 3.4-.1-2.2.2-4.5 1-6.6h-2.2C13 17.3 13.4 22.5 16 27c1.1 1.9 2.9 3.3 5 3.8s4.2.3 6.2-.8c1.4-.8 2.5-2 3.2-3.4.1 2.2-.2 4.5-1 6.6h2.2c1.4-4.6 1.1-9.8-1.5-14.3zm-4 9.4c-2.9 1.7-6.7.7-8.4-2.2l-.3-.6c-1.2-2.8-.2-6.2 2.5-7.7 2.9-1.7 6.7-.7 8.4 2.2l.3.6c1.2 2.8.2 6.1-2.5 7.7zM23 21c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0-2.1c-2.3 0-4.1 1.8-4.1 4.1s1.8 4.1 4.1 4.1 4.1-1.8 4.1-4.1-1.8-4.1-4.1-4.1z","fill":"#fff"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/slackFill.svg